<template>
    <v-tooltip-wrapper :disabled="!tooltipText"
                       :open-delay="tooltipDelay"
                       :open-on-click="false"
                       :tooltip-position="tooltipPosition"
                       :transition="tooltipTransition">
        <template #activator="{ on, attrs }">
            <v-btn-wrapper
                :aria-label="tooltipText"
                :class="[...buttonClasses, 'square-icon-button', 'v-btn--is-elevated', 'v-btn--has-bg']"
                :color="color"

                :disabled="disabled"
                :href="href"
                :loading="loading"
                :style="buttonStyle"
                :text="flat"
                v-bind="{...$attrs, ...attrs, ...btnSizeProps}"
                v-on="{...$listeners, ...on}">
                <v-icon v-bind="iconSizeProps">{{ icon }}</v-icon>
            </v-btn-wrapper>
        </template>

        <div class="icon-in-tooltip-container">
            <v-icon v-if="icon"
                    :color="iconColor"
                    class="icon-in-tooltip"
                    x-small>{{ icon }}
            </v-icon>
            <span v-if="tooltipText">{{ tooltipText }}</span>
        </div>
    </v-tooltip-wrapper>
</template>

<script>
import { defineComponent } from 'vue'
import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'

export default defineComponent({
    name: 'squareButton',
    components: { VTooltipWrapper },
    inheritAttrs: false,
    props: {
        disabled: Boolean,
        loading: Boolean,
        flat: Boolean,
        icon: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: 'secondary'
        },
        tooltipText: String,
        tooltipDelay: {
            type: Number,
            default: 650
        },
        /** @type {'top'|'bottom'|'left'|'right'} */
        tooltipPosition: {
            type: String,
            default: 'top'
        },
        tooltipTransition: String,
        buttonStyle: String,
        buttonClasses: {
            type: Array,
            default: () => []
        },
        href: String,
        size: String
    },
    computed: {
        btnSizeProps() {
            return {
                'x-small': this.size == 'x-small',
                'small': this.size == 'small',
                'large': this.size == 'large',
                'x-large': this.size == 'x-large'
            }
        },
        iconSizeProps() {
            return {
                'x-small': this.size == 'small' || this.size == 'x-small',
                'small': !this.size || this.size == 'medium',
                'large': this.size == 'x-large'
            }
        },
        iconColor() {
            // Make the button tooltip icon color primary if button color is secondary (better contrast)
            return this.color == 'secondary' ? 'primary' : this.color
        }
    }
})
</script>

<style>
    /* Modify padding so we get a rectangular button with an icon */
    .square-icon-button {
        padding: 0 8px !important;
        aspect-ratio: 1;
    }
</style>
